export enum MemorizedRuleType {
  NORMAL = 'Normal',
  AMOUNT_TYPE = 'Amount',
  ACCOUNT_TYPE = 'Account',
  ACCOUNT_AND_AMOUNT_TYPE = 'Amount & Account',
}
